import { createTheme } from '@mui/material/styles';
import indigo from '@mui/material/colors/indigo'
import grey from "@mui/material/colors/grey"

export const jsiTheme = createTheme({
    palette: {
        background: {
            paper: "#fbffff"
        },
        secondary: {
            main: "#D50000"
        }
    },
    typography: {
        h1: {
            textAlign: "center",
            fontSize: "1.25rem",
            marginTop: '.1rem'
        },
        body1: {
            fontSize: "1rem"
        }
    },
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: grey[50],
                lineHeight: "1",
            },
        },
        MuiTableCell: {
            head: {
                color: indigo[500]
            },
            root: {
                padding: '.1rem',
            }
        },
        MuiListItem: {
            root: {
                paddingTop: '.1px',
                paddingBottom: '.1px',
            },
            button: {
                textDecoration: "none",
                textDecorationColor: "white"
            }
        }
    }
})
export default jsiTheme